/**
 * Console visibility for stub/dev code paths. Filter: `[Lectura][non-production]`
 * @see docs/NON-PRODUCTION-SURFACE.md
 */
const lecturaNonProductionWarned = new Set<string>();

export function warnLecturaNonProduction(message: string, detail?: Record<string, unknown>): void {
  if (typeof console === 'undefined' || typeof console.warn !== 'function') return;
  const key = detail && Object.keys(detail).length > 0 ? `${message}\0${JSON.stringify(detail)}` : message;
  if (lecturaNonProductionWarned.has(key)) return;
  lecturaNonProductionWarned.add(key);
  if (detail && Object.keys(detail).length > 0) {
    console.warn(`[Lectura][non-production] ${message}`, detail);
  } else {
    console.warn(`[Lectura][non-production] ${message}`);
  }
}
